import React from "react";

const Imprint = () => {
  return <div>Imprint</div>;
};

export default Imprint;



// WEBPACK FOOTER //
// ./src/components/Pages/Imprint/Imprint.js